<template>
	<div class="my-tinymce">
		<Editor v-model="contentValue" :init="myInit" :disabled="disabled" />
	</div>
</template>

<script>
	import {
		url,
		mediaUrl
	} from '@/api/url'
	import {
		ElLoading
	} from 'element-plus'
	import {
		onMounted,
		onUnmounted,
		reactive,
		toRefs,
		watch,
		nextTick
	} from 'vue'
	import axios from 'axios'
	// 引入tinymce编辑器
	import Editor from '@tinymce/tinymce-vue'
	import tinymce from 'tinymce/tinymce' // tinymce默认hidden，不引入则不显示编辑器
	// 导入配置文件
	import './teditorjs/importTinymce'
	import {
		init
	} from './teditorjs/config'
	import {
		setStorage,
		getStorage,
		getToken
	} from '@/utils/util'
	let token = getToken()

	export default {
		name: 'tEditor',
		components: {
			Editor
		},
		props: {
			// 绑定文本值
			modelValue: {
				type: String,
				default: ''
			},
			// placeholder
			placeholder: {
				type: String,
				default: '请输入内容'
			},
			disabled: {
				type: Boolean,
				default: false
			},
			// 默认样式
			style: {
				type: Object,
				default: () => {
					return {
						width: '100%',
						heigth: '300'
					}
				}
			},
			// 图片上传服务器地址
			imgUploadUrl: {
				type: String,
				default: ''
			}
		},
		setup(props, {
			emit
		}) {
			const state = reactive({
				myInit: customer(init), // 初始化
				contentValue: props.modelValue, // 绑定文本
				timeout: null,
			})
			token = getToken()

			onMounted(() => {
				nextTick(() => {
					tinymce.init({})
				})
				window.addEventListener("focusin", onFocusIn, true);
			})
			onUnmounted(() => {
				// tinymce.remove()
				window.removeEventListener("focusin", onFocusIn);
			})


			// 侦听文本变化并传给外界
			watch(() => state.contentValue, (n) => {
				debounce(() => {
					emit('update:modelValue', state.contentValue)
				})
			})
			// 侦听默认值 外界第一次传进来一个 v-model 就赋值给 contentValue
			watch(() => props.modelValue, (n) => {
				if (n && n !== state.contentValue) {
					state.contentValue = n
				}
			})

			function onFocusIn(e) {
				e.stopImmediatePropagation() //阻止当前和后面的一系列事件
			}

			function debounce(fn, wait = 400) {
				// console.log('进到了防抖', wait)
				if (state.timeout !== null) {
					clearTimeout(state.timeout)
				}
				state.timeout = setTimeout(fn, wait)
			}

			// 参数自定义初始化
			function customer(init) {
				// 允许外界传进来高度和placeholder
				init.height = props.style.heigth
				init.placeholder = props.placeholder

				// 粘贴图片 自动处理 base64
				init.urlconverter_callback = (url, node, onSave, name) => {
					// console.log(tinymce.activeEditor)
					if (node === 'img' && url.startsWith('blob:')) {
						tinymce.activeEditor && tinymce.activeEditor.uploadImages()
					}
					return url
				}
				// 图片上传
				init.images_upload_handler = (blobInfo, success, failure) => {
					imgUploadFn(blobInfo, success, failure)
				}
				//视频上传
				init.file_picker_callback = (callback, valute, meta) => {
					viedoUploadFn(callback, valute, meta)
				}
				return init
			}

			//随机生成随机数
			function generateRandomString(length) {
				const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
				let result = ''
				const charactersLength = characters.length
				for (let i = 0; i < length; i++) {
					result += characters.charAt(Math.floor(Math.random() * charactersLength))
				}
				return result
			}

			function viedoUploadFn(callback, valute, meta) {
				if (meta.filetype == 'media') {
					
					const input = document.createElement('input')
					input.setAttribute('type', 'file')
					input.addEventListener("change",e=> {
						const loading = ElLoading.service({
							lock: true,
							text: '文件上传中...',
							background: 'rgba(0, 0, 0, 0.7)',
						})
						let box = document.querySelector(".el-loading-mask");
						box.style.zIndex = "999999999"
						
						console.log(ElLoading,loading)
						const params = new FormData()
						const blob = e.target.files[0]
						params.append('file', blob)
						params.append('dirs', 'media')

						const config = {
							headers: {
								'Content-Type': 'multipart/form-data',
								'Authorization': 'JWT ' + token
							}
						}
						const uploadurl = url + 'article/upload/'
						axios.post(uploadurl, params, config).then(res => {
							if (res.data.code == 2000) {
								let imgpath = ''
								if (res.data.data.data[0].indexOf("://") >= 0) imgpath = res.data.data.data[0]
								else imgpath = "http://" + mediaUrl + '/media' + res.data.data.data[0]
								callback(imgpath, {
									title: blob.name
								})
							} else callback(res.data.msg, {
								title: blob.name
							})
							loading.close()
						}).catch(err => {
							callback("视频由于不可抗力因素导致上传失败，请联系管理员后上传", {
								title: blob.name
							})
							loading.close()
						})
					})
					input.click()
				}
			}

			function imgUploadFn(blobInfo, success, failure) {
				// 可以限制图片大小
				// if (blobInfo.blob().size / 1024 / 1024 > 2) {
				//   failure('上传失败，图片大小请控制在 2M 以内')
				// } else {}
				const params = new FormData()
				const blob = blobInfo.blob()
				const formater = blob.type.substr(blob.type.lastIndexOf("/") + 1)

				params.append('file', blob, generateRandomString(10) + "." + formater)
				params.append('dirs', 'article')

				const config = {
					headers: {
						'Content-Type': 'multipart/form-data',
						'Authorization': 'JWT ' + token, // 可选参数(服务器上传验证需要) 如果需要token验证，假设你的token有存放在sessionStorage
					}
				}
				// const uploadurl = url + 'platformsettings/uploadplatformimg/'
				const uploadurl = url + 'article/upload/'
				// 图片上传
				axios.post(uploadurl, params, config).then(res => {

					if (res.data.code == 2000) {
						//这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
						let imgpath = ''
						if (res.data.data.data[0].indexOf("://") >= 0) {
							imgpath = res.data.data.data[0]

						} else {
							imgpath = "http://" + mediaUrl + '/media' + res.data.data.data[0]
						}
						success(imgpath) // 上传成功，在成功函数里填入图片路径
						// console.log('[文件上传]', res.data)
					} else {
						failure('上传失败')
					}
				}).catch(() => {
					failure('上传出错，服务器开小差了呢')
				})
			}

			return ({
				...toRefs(state),
				customer,
				debounce
			})
		}
	}
</script>

<style lang="css">
	.my-tinymce {
		width: 100%;
	}

	.tox-notifications-container {
		display: none;
	}

	/*.tox-tinymce-aux {*/
	/*  z-index: 5000 !important;*/
	/*}*/
</style>